export default {
  namespaced: true,
  state: {
    pageProperties: {
      pageTitle: '',
      showCompanyPicker: '',
      checkoutLayout: false
    }
  },
  getters: {
    getPageProperties: state => state.pageProperties,
  },
  mutations: {
    // set using: this.$store.commit('setPageTitle', 'Invoice Settings page title')
    setPageTitle (state, title) {
      state.pageProperties.pageTitle = title;
    },
    showCompanyPicker (state, visible) {
      state.pageProperties.showCompanyPicker = visible;
    },
    setCheckoutLayout (state, data) {
      state.pageProperties.checkoutLayout = data;
    },
  },
  actions: {
    // set using: this.$store.dispatch('setPageProperties', {x:"y",z:true})
    setPageProperties({ commit }, data){
      commit('setPageTitle', data.title);
      commit('showCompanyPicker', data.showCompanyPicker);
      commit('setCheckoutLayout', (!data.checkoutLayout) ? null : data.checkoutLayout);
    }
  }
};
